// extracted by mini-css-extract-plugin
export var component = "world-map-module--component--28YBh";
export var title = "world-map-module--title--28AgH";
export var hr = "world-map-module--hr--2QJB-";
export var content = "world-map-module--content--15ptF";